import { ModalService } from './shared/utils/services/modal.service';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppService } from './app.service';
import { SplashLoaderComponent } from './shared/ui/splash-loader/splash-loader.component';
import { ModalComponent } from './shared/ui/modal/modal.component';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    SplashLoaderComponent,
    ModalComponent,
    TranslocoModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  public appService = inject(AppService);
  public modalService = inject(ModalService);
  loading = signal<boolean>(false);
  title = 'QwikoPay';

  constructor() {
    this.loading.set(this.appService.loading());
    effect(() => {
      if (this.appService.loading()) {
        this.loading.set(true);
      } else {
        this.loading.set(false);
      }
    });
  }

  async ngAfterViewInit(): Promise<void> {
    await this.appService.init();
  }

  install() {
    this.appService.installApp();
    this.modalService.close('install_modal');
  }

  reload() {
    window.location.reload();
  }
}
